export const templateWorkOrderMassiveProcess =
  'template_massive_process_work_order.xlsx'

export const templateMassiveProcessInventory =
  'template_massive_process_inventory.xlsx'

export const templateMassiveProcessInternalOrder =
  'template_massive_process_internal_order.xlsx'

export const templateCreateMassiveProcessPositions =
  'template_create_massive_process_positions.xlsx'

export const templateEditMassiveProcessPositions =
  'template_edit_massive_process_positions.xlsx'

export const templateMassiveInventoryCheck =
  'template_massive_inventory_check.xlsx'
export const templateCreateMassiveOrderRecall =
  'template_massive_create_order_recall.xlsx'

export const templateUpdateStockPreSaleSku =
  'template_update_stock_venta_en_verde_sku.xlsx'

export const templateMassiveProcessPackingList =
  'template_massive_process_packing_list.xlsx'
